export { default as PlaySolidIcon } from './PlaySolidIcon';
